module.exports = __webpack_public_path__ + "static/media/top-slide-5.4150ffa7.jpeg";